import React from "react";
import { format, parse } from "date-fns";
import { DateRange } from "react-day-picker";

interface MobileDateRangeFieldsProps {
  value: DateRange | undefined;
  onChange: (range: DateRange | undefined) => void;
}

const toInputValue = (date?: Date) => (date ? format(date, "yyyy-MM-dd") : "");
const fromInputValue = (value: string) =>
  value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;

const inputClassName =
  "h-11 w-full min-w-0 rounded-xl border-0 bg-white px-3 text-[15px] text-gray-900 shadow-[0_1px_2px_rgba(13,14,19,0.04)] ring-1 ring-gray-100 focus:outline-none focus:ring-2 focus:ring-primary-500";

/** Native date pickers; popover calendars don't fit or layer correctly inside bottom sheets. */
const MobileDateRangeFields: React.FC<MobileDateRangeFieldsProps> = ({ value, onChange }) => {
  const update = (range: DateRange) =>
    onChange(range.from || range.to ? range : undefined);

  return (
    <div className="grid grid-cols-2 gap-2">
      <label className="space-y-1">
        <span className="block text-[11px] font-medium text-gray-500">From</span>
        <input
          type="date"
          value={toInputValue(value?.from)}
          max={toInputValue(value?.to) || undefined}
          onChange={(event) => update({ from: fromInputValue(event.target.value), to: value?.to })}
          className={inputClassName}
        />
      </label>
      <label className="space-y-1">
        <span className="block text-[11px] font-medium text-gray-500">To</span>
        <input
          type="date"
          value={toInputValue(value?.to)}
          min={toInputValue(value?.from) || undefined}
          onChange={(event) => update({ from: value?.from, to: fromInputValue(event.target.value) })}
          className={inputClassName}
        />
      </label>
    </div>
  );
};

export default MobileDateRangeFields;
